import { z } from 'zod';

export const UserPutSchema = z.object({
   username: z
      .string()
      .min(3, { message: 'Username must be at least 3 characters long' })
      .max(20, { message: 'Username must be at most 20 characters long' })
      .optional()
      .nullable(),
   phrase: z.string().nullable().optional(),
   // isVisible: z.boolean(),
   fullname: z.string().nullable().optional(),
   address: z.string().nullable().optional(),
   city: z.string().nullable().optional(),
   state: z.string().nullable().optional(),
   zip: z.string().nullable().optional(),
   country: z.string().nullable().optional(),
   phone: z.string().nullable().optional(),
});
